<template lang="pug">
    Modal
        .form
            h2  Add a New Localized Content Record to Media Library
            .form__control-group.rule__control-group--select
                label Select New Locale
                select.form__select(
                    v-model="newLocale"
                )
                    option(
                        v-for="market in getAvailableMarkets"
                    ) {{market.locale}}
            button.button__submit(
                @click="submit"
            ) Add Record To Media Library
</template>
<script>
import Modal from '../general/Modal';
import store from '../../store';
import Services from '../../services/Services';
import { postResource } from '../../services/Utils.js';
import VueNotifications from 'vue-notifications';
export default {
    name: 'CreateMediaLibraryLocalRecord',
    components: {
        Modal
    },
    data() {
        return {
            newLocale: '',
        }
    },
    computed: {
        getActiveMediaLibrary() {
            return store.getters.getActiveMediaLibrary;
        },
        getAvailableMarkets() {
            return store.getters.getMarkets;
        }
    },
    notifications: {
        showSuccessMsg: {
        type: VueNotifications.types.success,
        title: '',
        icon: '✅'
        },
        showErrorMsg: {
        type: VueNotifications.types.error,
        title: '',
        icon: '❗️'
        }
    },
    mounted(){
        Services.getMarkets();
    },
    methods: {
        submit(){
            let newRecord = {
                recordId: this.getActiveMediaLibrary._id,
                recordType: 'MediaLibrary',
                locale: this.newLocale
            }

            postResource('/v1/medialibraries/addLocalRecord', false, newRecord)
                .then(res => {
                    console.log('success!', res);
                    this.showSuccessMsg({ message: `New ${this.newLocale} record added to ${this.getActiveMediaLibrary.title}!` });
                    store.commit('hideModals', true);
                    Services.setActiveMediaLibrary(this.getActiveMediaLibrary._id, this.$router.push(`/media-libraries/${this.getActiveMediaLibrary._id}`));
                    return res;
                })
                .catch(error => {
                    let message = 'An error occurred. Please try again.';
                    if(error.error){
                        message = error.error;
                    }
                    this.showErrorMsg({
                    message
                    });
                });
        }
    }
}
</script>
<style lang="scss" scoped>
h2 {
    text-align: center;
}

.form {
    padding: 2rem;
}

.form__control-group.rule__control-group--select:after {
    top: 20px;
}

button {
    margin: 2rem auto 0;
}
</style>



// WEBPACK FOOTER //
// src/components/modals/CreateMediaLibraryLocalRecord.vue